<template>
    <!-- Note: 这里必须保证 只有 add-container 一个节点 -->
    <add-container
        ref="container"
        :init-item="()=>initBaozhiqi(flowSpecByCategoryInfo)"
        :item-list="data"
        :all-city-list="allCityList"
        :public-city-ids="publicCityIds"
        :is-required="isRequired"
        :can-delete-condition="canDeleteCondition"
        :disabled="disabled"
        title="保质期"
    >
        <div
            slot-scope="scope"
            :class="{'existed-ids-disabled': scope.item.existedIds && scope.item.existedIds.length > 0}"
        >
            <xx-form-item
                class="is-required"
                label="保质期"
                :prop="`guaranteePeriod.${scope.$index}`"
                :rules="rules.guaranteePeriod"
            >
                <el-input-number
                    v-if="scope.item.guaranteePeriodType !== 0"
                    v-model="scope.item.guaranteePeriod"
                    :controls="false"
                    placeholder="请输入"
                    class="input-with-select"
                    :disabled="disabled"
                    :style="{'width': '130px !important'}"
                    @change="(value) => {onTypeChange(value,scope.item.guaranteePeriodType, scope.item)}"
                />
                <xx-select
                    v-model="scope.item.guaranteePeriodType"
                    :clearable="false"
                    style="width: 130px !important"
                    dic-code="special:product:newsell_guaranteePeriodType"
                    :disabled="disabled"
                    @change="(type) => {onTypeChange(scope.item.guaranteePeriod, type, scope.item)}"
                />
                <example-pic type="guaranteePeriod" />
            </xx-form-item>
            <xx-form-item
                v-if="isShowReason(scope.item)"
                class="is-required"
                label="修改原因"
                :prop="`guaranteePeriod.${scope.$index}`"
                :rules="rules.guaranteePeriodChangeReason"
            >
                <mc-select
                    v-model="scope.item.guaranteePeriodChangeReason"
                    :source="{dictCode:'special:product:guarantee_period_change_reason'}"
                    :scroll-step="{size: 20}"
                    :disabled="disabled"
                />
            </xx-form-item>
            <div
                v-if="guaranteePeriodAdviceNumberDay"
                class="description"
            >
                建议填写保质期  <span class="prompt-day">{{ guaranteePeriodAdviceNumberDay }}</span>,
                如不符合实际情况，请按实际情况填写，例：商品包装上带有保质期的，以包装上保质期为准
            </div>
        </div>
    </add-container>
</template>

<script>
import AddContainer from './addContainer';
import { initBaozhiqi, guaranteePeriodTypeEnum, guaranteePeriodTypeMap } from './config';
import autoFillCityId from './mixins/autoFillCityId';
import ExamplePic from '../components/ExamplePicDialog';

export default {
    components: {
        AddContainer,
        ExamplePic,
    },
    mixins: [autoFillCityId],
    props: {
        data: {
            type: Array,
            default: () => [],
        },
        allCityList: {
            type: Array,
            default: () => [],
        },
        publicCityIds: {
            type: Array,
            default: () => [],
        },
        // 是否有默认保质期
        guaranteePeriodAdviceNumberDay: {
            type: [String, Number],
            default: '',
        },

        // 是否至少保留一个item，“是”则第一个item没有delete按钮
        isRequired: {
            type: Boolean,
            default: true,
        },
        canDeleteCondition: {
            type: Function,
            default: () => true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        flowSpecByCategoryInfo: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        const isIntegerAndInRange = (value, min, max) => {
            const isInteger = Number.isInteger(value);
            const inRange = value > min && value < max;
            return isInteger && inRange;
        };
        const guaranteePeriodValid = (rule, value, callback) => {
            if (value.guaranteePeriodType !== 0 && !value.guaranteePeriodType) {
                callback('保质期单位必选');
            } else if (value.guaranteePeriodType === 0) {
                callback(); // 无保质期限制，不做校验
            } else if (!isIntegerAndInRange(value.guaranteePeriod, 0, 999999)) {
                callback(new Error('保质期大于0并且小于999999的整数'));
            } else {
                callback();
            }
        };
        const guaranteePeriodReasonValid = (rule, value, callback) => {
            if (value.guaranteePeriodChangeReason) {
                callback();
            } else {
                callback('保质期原因必填');
            }
        };
        return {
            initBaozhiqi,
            rules: {
                guaranteePeriod: [
                    {
                        validator: guaranteePeriodValid,
                    },
                ],
                guaranteePeriodChangeReason: [{ validator: guaranteePeriodReasonValid }],
            },
        };
    },
    computed: {
        // 是否展示保质期原因（当用户填写的保质期不等于建议保质期）
        isShowReason() {
            return (row) => {
                const guaranteePeriodType = guaranteePeriodTypeEnum.find((item) => row.guaranteePeriodType === item.value);
                if (!guaranteePeriodType) return false;
                const userEnteredPeriod = row.guaranteePeriodType ? row.guaranteePeriod + guaranteePeriodType.label : guaranteePeriodType.label;
                return this.guaranteePeriodAdviceNumberDay && userEnteredPeriod !== this.guaranteePeriodAdviceNumberDay;
            };
        },
    },
    created() {
    },
    methods: {
        getData() {
            return this.$refs.container.getData();
        },
        onTypeChange(value, type, item) {
            if (type === guaranteePeriodTypeMap.indefinite) {
                item.guaranteePeriod = '';
            }
            this.handleReason(item);
        },
        // 清空保质期原因
        handleReason(item) {
            if (!this.isShowReason) {
                item.guaranteePeriodChangeReason = '';
            }
        },
    },
};
</script>

<style scoped lang="scss">
.existed-ids-disabled {
    position: relative;
    &::after {
       content: '';
       top: 0;
       right: 0;
       bottom: 0;
       left: 0;
       position: absolute;
       z-index: 2;
       cursor: not-allowed;
   }
}
.description{
    color: #95989E;
    margin-left: 130px;
    font-size: 12px;
}
.prompt-day{
    font-size: 18px;
    color: red;
    font-weight: 700;
}
::v-deep .el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus {
    border-color: #EB2F3C !important;
}
</style>
